import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, CalendarDays, Users, Home } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function SearchModule({ variant = "hero" }) {
  const { t } = useI18n();
  const nav = useNavigate();
  const [arrivee, setArrivee] = useState("");
  const [depart, setDepart] = useState("");
  const [adultes, setAdultes] = useState(2);
  const [enfants, setEnfants] = useState(0);
  const [type, setType] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    if (arrivee) p.set("arrivee", arrivee);
    if (depart) p.set("depart", depart);
    p.set("adultes", String(adultes));
    p.set("enfants", String(enfants));
    p.set("voyageurs", String(adultes + enfants));
    if (type) p.set("type", type);
    nav(`/disponibilites?${p.toString()}`);
  };

  const field = "flex flex-col gap-1 flex-1 min-w-[130px]";
  const label = "text-[11px] uppercase tracking-wider font-medium text-ink-400 flex items-center gap-1.5";
  const input = "bg-transparent border-0 border-b border-ink-400/25 focus:border-brand focus:ring-0 px-0 py-1.5 text-ink font-body text-sm outline-none";

  return (
    <form
      onSubmit={submit}
      data-testid="search-module"
      className={`bg-white rounded-3xl border border-black/5 shadow-[0_16px_48px_rgba(44,48,48,0.12)] p-5 sm:p-6 flex flex-col md:flex-row md:items-end gap-4 md:gap-5 ${
        variant === "hero" ? "" : ""
      }`}
    >
      <div className={field}>
        <span className={label}><CalendarDays size={13} strokeWidth={1.75} />{t("common.arrival")}</span>
        <input type="date" value={arrivee} onChange={(e) => setArrivee(e.target.value)} className={input} data-testid="search-arrivee" />
      </div>
      <div className={field}>
        <span className={label}><CalendarDays size={13} strokeWidth={1.75} />{t("common.departure")}</span>
        <input type="date" value={depart} onChange={(e) => setDepart(e.target.value)} className={input} data-testid="search-depart" />
      </div>
      <div className={field}>
        <span className={label}><Users size={13} strokeWidth={1.75} />{t("common.adults")}</span>
        <select value={adultes} onChange={(e) => setAdultes(Number(e.target.value))} className={input} data-testid="search-adultes">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      <div className={field}>
        <span className={label}><Users size={13} strokeWidth={1.75} />{t("common.children")}</span>
        <select value={enfants} onChange={(e) => setEnfants(Number(e.target.value))} className={input} data-testid="search-enfants">
          {[0, 1, 2, 3, 4, 5, 6].map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      <div className={field}>
        <span className={label}><Home size={13} strokeWidth={1.75} />{t("common.accommodationType")}</span>
        <select value={type} onChange={(e) => setType(e.target.value)} className={input} data-testid="search-type">
          <option value="">{t("common.any")}</option>
          <option value="chambre">{t("common.chambre")}</option>
          <option value="gite">{t("common.gite")}</option>
        </select>
      </div>
      <button
        type="submit"
        data-testid="search-submit"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-brand text-white px-7 py-3.5 font-medium hover:bg-brand-600 transition-colors hover:scale-[1.02] active:scale-[0.98] shrink-0"
      >
        <Search size={18} strokeWidth={2} />
        {t("common.search")}
      </button>
    </form>
  );
}
